const ConfirmDeleteModal = ({
  open,
  onClose,
  onConfirm,
  fileName,
  isBulk,
  loading,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-lg w-full max-w-md p-6 shadow-lg text-start">
        <h3 className="text-lg font-semibold mb-3 text-gray-900">
          Confirm Delete
        </h3>

        <p className="text-sm text-gray-700 mb-6">
          {isBulk ? (
            <>Are you sure you want to delete the selected documents?</>
          ) : (
            <>
              Are you sure you want to delete{" "}
              <span className="font-semibold text-gray-900">
                “{fileName} ”
              </span>
               {' '}?
            </>
          )}
        </p>

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            disabled={loading}
            className="px-4 py-2 text-sm border rounded hover:bg-gray-100 disabled:opacity-50"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            disabled={loading}
            className="px-4 py-2 text-sm bg-red-600 text-white rounded hover:bg-red-700 disabled:opacity-50"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteModal;
